import { render, staticRenderFns } from "./AllTables.vue?vue&type=template&id=001046b5&scoped=true"
import script from "./AllTables.vue?vue&type=script&lang=js"
export * from "./AllTables.vue?vue&type=script&lang=js"
import style0 from "./AllTables.vue?vue&type=style&index=0&id=001046b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001046b5",
  null
  
)

export default component.exports